<template>
  <el-dialog title="打印预览" :visible.sync="show" fullscreen :before-close="handleClose">
    <div>
      <span style="display: flex; margin-bottom: 20px;" class="dialog-footer">
        <div style="flex: 1;" />
        <el-button type="primary" @click="print">打印</el-button>
        <el-button @click="show=false">取消</el-button>
      </span>
    </div>

    <!-- 打印内容区域 -->
    <div id="printId">
      <!-- 报告标题 -->
      <div style="display: flex; justify-content: center; align-items: center; font-size: 24px; margin-bottom: 20px; margin-top: 20px;">
        体质检测分析报告
      </div>

      <!-- 基本信息表格 -->
      <div style="display: flex; justify-content: center; align-items: center;">
        <div>
          <div style="display: flex;">
            <div class="formItem">昵称</div>
            <div class="formItemwhite">{{ printData.userName }}</div>
            <div class="formItem">性别</div>
            <div class="formItemwhite">{{ printData.sexSign == 1 ? '男' : '女' }}</div>
          </div>
          <div style="display: flex;">
            <div class="formItem">年龄</div>
            <div class="formItemwhite">{{ printData.age }}</div>
            <div class="formItem">出生日期</div>
            <div class="formItemwhite">{{ printData.birthDate }}</div>
          </div>
          <div style="display: flex;">
            <div class="formItem">检测日期</div>
            <div class="formItemwhite">{{ printData.diagTime }}</div>
            <div class="formItem">检测门店</div>
            <div class="formItemwhite">{{ printData.storeName }}</div>
          </div>
          <div style="display: flex;">
            <div class="formItem">门店地址</div>
            <div class="formItemwhite">{{ printData.contactAddress }}</div>
            <div class="formItem">联系电话</div>
            <div class="formItemwhite">{{ printData.contactPhone }}</div>
          </div>
        </div>
      </div>

      <!-- 体质部分标题 -->
      <div style="margin: 30px 0 10px 0; font-size: 18px; font-weight: bold; display: flex;">
        <div style="border-left: 5px solid rgb(22, 93, 255); padding:0 0 10px 10px; margin-left: 10px;" />
        体质
      </div>

      <!-- 体质模块 -->
      <div style="padding: 10px;">
        <!-- 计算副体质数量 -->
        <div v-if="subPhyCount === 0">
          <!-- 没有副体质时，只显示主体质 -->
          <div class="main-phy-large" style="display: flex; align-items: center; justify-content: center; padding: 20px; background: linear-gradient(135deg, #f8f9ff 0%, #e8f0ff 100%); border-radius: 12px; margin: 20px auto; max-width: 600px;">
            <div style="display: flex; align-items: center; width: 100%;">
              <div style="margin-right: 20px;">
                <img v-if="printData.mainPhyCode" :src="require(`@/assets/health/${printData.mainPhyCode}.png`)" alt="" style="width: 80px; height: 80px;">
              </div>
              <div style="flex: 1;">
                <div style="font-size: 20px; font-weight: bold; color: #165dff; margin-bottom: 8px;">
                  {{ printData.mainPhyName }}
                </div>
                <div style="font-size: 16px; color: #666;">
                  程度：<span style="font-weight: bold; color: #165dff;">{{ printData.mainPhyPct }}%</span>
                </div>
              </div>
              <div>
                <img src="@/assets/icon/zhutizhi.png" alt="" style="width: 60px; height: 60px;">
              </div>
            </div>
          </div>
        </div>

        <div v-else-if="subPhyCount === 1">
          <!-- 只有一个副体质时，主体质和副体质在同一行 -->
          <div style="display: flex; justify-content: space-between; align-items: stretch; margin: 20px auto; max-width: 800px;">
            <!-- 主体质 - 放大显示 -->
            <div class="main-phy-large" style="flex: 2; margin-right: 15px; padding: 25px; background: linear-gradient(135deg, #f8f9ff 0%, #e8f0ff 100%); border-radius: 12px; display: flex; align-items: center;">
              <div style="margin-right: 20px;">
                <img v-if="printData.mainPhyCode" :src="require(`@/assets/health/${printData.mainPhyCode}.png`)" alt="" style="width: 80px; height: 80px;">
              </div>
              <div style="flex: 1;">
                <div style="font-size: 22px; font-weight: bold; color: #165dff; margin-bottom: 8px;">
                  {{ printData.mainPhyName }}
                </div>
                <div style="font-size: 18px; color: #666;">
                  程度：<span style="font-weight: bold; color: #165dff;">{{ printData.mainPhyPct }}%</span>
                </div>
              </div>
              <div>
                <img src="@/assets/icon/zhutizhi.png" alt="" style="width: 60px; height: 60px;">
              </div>
            </div>

            <!-- 副体质 -->
            <div v-for="item in getSubPhyList()" :key="item.index" class="sub-phy-item" style="flex: 1; padding: 20px; background: #f9fafc; border-radius: 10px; border: 1px solid #e5e7eb; display: flex; align-items: center; margin-left: 15px;">
              <div style="margin-right: 15px;">
                <img :src="require(`@/assets/health/${item.code}.png`)" alt="" style="width: 50px; height: 50px;">
              </div>
              <div style="flex: 1;">
                <div style="font-size: 16px; font-weight: 600; color: #333; margin-bottom: 5px;">
                  {{ item.name }}
                </div>
                <div style="font-size: 14px; color: #666;">
                  程度：{{ item.pct }}%
                </div>
              </div>
              <div>
                <img src="@/assets/icon/futizhi.png" alt="" style="width: 40px; height: 40px;">
              </div>
            </div>
          </div>
        </div>

        <div v-else>
          <!-- 有多个副体质时，主体质单独一行放大显示，副体质在下面 -->
          <!-- 主体质 - 放大显示 -->
          <div class="main-phy-large" style="padding: 25px; background: linear-gradient(135deg, #f8f9ff 0%, #e8f0ff 100%); border-radius: 12px; margin: 20px auto; max-width: 700px; display: flex; align-items: center;">
            <div style="margin-right: 20px;">
              <img v-if="printData.mainPhyCode" :src="require(`@/assets/health/${printData.mainPhyCode}.png`)" alt="" style="width: 80px; height: 80px;">
            </div>
            <div style="flex: 1;">
              <div style="font-size: 22px; font-weight: bold; color: #165dff; margin-bottom: 8px;">
                {{ printData.mainPhyName }}
              </div>
              <div style="font-size: 18px; color: #666;">
                程度：<span style="font-weight: bold; color: #165dff;">{{ printData.mainPhyPct }}%</span>
              </div>
            </div>
            <div>
              <img src="@/assets/icon/zhutizhi.png" alt="" style="width: 60px; height: 60px;">
            </div>
          </div>

          <!-- 副体质列表 -->
          <div style="display: flex; flex-wrap: wrap; justify-content: center; margin-top: 30px;">
            <div v-for="item in getSubPhyList()" :key="item.index" class="sub-phy-item" style="width: 280px; margin: 10px; padding: 15px; background: #f9fafc; border-radius: 10px; border: 1px solid #e5e7eb; display: flex; align-items: center;">
              <div style="margin-right: 15px;">
                <img :src="require(`@/assets/health/${item.code}.png`)" alt="" style="width: 50px; height: 50px;">
              </div>
              <div style="flex: 1;">
                <div style="font-size: 16px; font-weight: 600; color: #333; margin-bottom: 5px;">
                  {{ item.name }}
                </div>
                <div style="font-size: 14px; color: #666;">
                  程度：{{ item.pct }}%
                </div>
              </div>
              <div>
                <img src="@/assets/icon/futizhi.png" alt="" style="width: 40px; height: 40px;">
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 面诊部分标题 -->
      <div style="margin: 30px 0 10px 0; font-size: 18px; font-weight: bold; display: flex;">
        <div style="border-left: 5px solid rgb(22, 93, 255); padding:0 0 10px 10px; margin-left: 10px;" />
        面诊
      </div>

      <!-- 面诊图片 -->
      <div style="text-align: center; margin: 10px 0; ">
        <img style="height: 200px;" :src="getsrc(printData.faceImg)" alt="">
      </div>

      <!-- 面诊表格 -->
      <div style="display: flex; justify-content: center; align-items: center;">
        <div>
          <div style="display: flex;">
            <div class="formItem">指标</div>
            <div class="formItem" style="width: 300px;">说明</div>
          </div>
          <div style="display: flex;">
            <div class="formItemwhite">面部颜色</div>
            <div class="formItemwhite" style="width: 300px; background: #fff;">
              {{ getOptions('faceColorSign', printData.faceColorSign) }}
            </div>
          </div>
          <div style="display: flex;">
            <div class="formItemwhite">面部色泽</div>
            <div class="formItemwhite" style="width: 300px; background: #fff;">
              {{ getOptions('faceLustreSign', printData.faceLustreSign) }}
            </div>
          </div>
          <div style="display: flex;">
            <div class="formItemwhite">嘴唇检测</div>
            <div class="formItemwhite" style="width: 300px; background: #fff;">
              {{ getOptions('lipRecognitionSign', printData.lipRecognitionSign) }}
            </div>
          </div>
          <div style="display: flex;">
            <div class="formItemwhite">嘴唇</div>
            <div class="formItemwhite" style="width: 300px; background: #fff;">
              {{ getOptions('lipColorSign', printData.lipColorSign) }}
            </div>
          </div>
        </div>
      </div>

      <!-- 舌诊部分标题 -->
      <div style="margin: 30px 0 10px 0; font-size: 18px; font-weight: bold; display: flex;">
        <div style="border-left: 5px solid rgb(22, 93, 255); padding:0 0 10px 10px; margin-left: 10px;" />
        舌诊
      </div>

      <!-- 舌诊图片 -->
      <div style="text-align: center; margin: 10px 0;">
        <img style="height: 200px;" :src="getsrc(printData.tongueImg)" alt="">
      </div>

      <!-- 舌诊表格 -->
      <div style="display: flex; justify-content: center; align-items: center;">
        <div>
          <div style="display: flex;">
            <div class="formItem">指标</div>
            <div class="formItem" style="width: 300px;">说明</div>
          </div>
          <div style="display: flex;">
            <div class="formItemwhite">舌裂纹检测</div>
            <div class="formItemwhite" style="width: 300px; background: #fff;">
              {{ getOptions('tongueCrackSign', printData.tongueCrackSign) }}
            </div>
          </div>
          <div style="display: flex;">
            <div class="formItemwhite">舌胖瘦检测</div>
            <div class="formItemwhite" style="width: 300px; background: #fff;">
              {{ getOptions('tongueFatSign', printData.tongueFatSign) }}
            </div>
          </div>
          <div style="display: flex;">
            <div class="formItemwhite">舌苔厚薄检测</div>
            <div class="formItemwhite" style="width: 300px; background: #fff;">
              {{ getOptions('tongueCoatThickSign', printData.tongueCoatThickSign) }}
            </div>
          </div>
          <div style="display: flex;">
            <div class="formItemwhite">舌苔颜色检测</div>
            <div class="formItemwhite" style="width: 300px; background: #fff;">
              {{ getOptions('tongueCoatColorSign', printData.tongueCoatColorSign) }}
            </div>
          </div>
          <div style="display: flex;">
            <div class="formItemwhite">舌质颜色检测</div>
            <div class="formItemwhite" style="width: 300px; background: #fff;">
              {{ getOptions('tongueColorSign', printData.tongueColorSign) }}
            </div>
          </div>
        </div>
      </div>

      <!-- 方案部分标题 -->
      <div style="margin: 30px 0 10px 0; font-size: 18px; font-weight: bold; display: flex;">
        <div style="border-left: 5px solid rgb(22, 93, 255); padding:0 0 10px 10px; margin-left: 10px;" />
        方案
      </div>

      <!-- 方案内容 -->
      <div style="text-align: start; padding: 0 20px;" v-html="schemeHtml.head ? schemeHtml.head.htmlContent : ''" />
      <div style="display: flex; justify-content: center;align-items: center; width: 100%; margin-top: 30px;">
        <div style="display: flex; flex-direction: column;justify-content: center;align-items: center; padding: 20px; border: 1px solid #eee; border-radius: 8px;">
          <!-- 修改图片路径处理 -->
          <img src="@/assets/health/qr.jpg" style="width: 120px; height: 120px; object-fit: contain;">
          <div style="margin-top: 10px; font-size: 14px; color: #666;">
            扫码在手机上查看报告
          </div>
        </div>
      </div>
    </div></el-dialog>
</template>
<script>
import { getSrc } from '@/utils/ik/oss/oss.js'
export default {
  props: {
    printData: {
      type: Object,
      default: function() {
        return {}
      }
    },
    schemeList: {
      type: Array,
      default: function() {
        return []
      }
    },
    schemeHtml: {
      type: Object,
      default: function() {
        return {}
      }
    }
  },
  data() {
    return {
      show: false,
      // 列表内容
      columns: [
        {
          code: "code",
          name: "编码",
          span: 6,
          type: "text",
          config: {
            edit: false
          }
        },
        {
          code: "name",
          name: "名称",
          span: 6,
          type: "text",
          config: {
            edit: false
          }
        },
        {
          code: "userCode",
          name: "用户编码",
          span: 6,
          type: "text",
          config: {
            edit: false
          }
        },
        {
          code: "userName",
          name: "用户名称",
          span: 6,
          type: "text",
          config: {
            edit: false
          }
        },
        {
          code: "robotCode",
          name: "机器人编码",
          span: 6,
          type: "text",
          config: {
            edit: false
          }
        },
        {
          code: "robotName",
          name: "机器人名称",
          span: 6,
          type: "text",
          config: {
            edit: false
          }
        },
        {
          code: "stateSign",
          name: "报告状态标识",
          type: "select",
          span: 6,
          config: {
            edit: false,
            keyField: "key",
            valueField: "value",
            options: [
              { key: "1", value: "未出报告" },
              { key: "2", value: "已出报告" }
            ]
          }
        },
        {
          code: "diagTime",
          name: "诊断时间",
          type: "datetime",
          span: 6,
          config: {
            edit: false
          }
        },
        {
          code: "mainPhyCode",
          name: "主体质编码",
          type: "text",
          span: 6,
          config: {
            edit: false
          }
        },
        {
          code: "mainPhyName",
          name: "主体质名称",
          type: "text",
          span: 6,
          config: {
            edit: false
          }
        },
        {
          code: "mainPhyPct",
          name: "主体质程度",
          type: "number",
          span: 6,
          config: {
            edit: false
          }
        },
        {
          code: "phy1Code",
          name: "副体质1编码",
          type: "text",
          span: 6,
          config: {
            edit: false
          }
        },
        {
          code: "phy1Name",
          name: "副体质1名称",
          type: "text",
          span: 6,
          config: {
            edit: false
          }
        },
        {
          code: "phyPct1",
          name: "副体质1程度",
          type: "number",
          span: 6,
          config: {
            edit: false
          }
        },
        {
          code: "phy2Code",
          name: "副体质2编码",
          type: "text",
          span: 6,
          config: {
            edit: false
          }
        },
        {
          code: "phy2Name",
          name: "副体质2名称",
          type: "text",
          span: 6,
          config: {
            edit: false
          }
        },
        {
          code: "phyPct2",
          name: "副体质2程度",
          type: "number",
          span: 6,
          config: {
            edit: false
          }
        },
        {
          code: "phy3Code",
          name: "副体质3编码",
          type: "text",
          span: 6,
          config: {
            edit: false
          }
        },
        {
          code: "phy3Name",
          name: "副体质3名称",
          type: "text",
          span: 6,
          config: {
            edit: false
          }
        },
        {
          code: "phyPct3",
          name: "副体质3程度",
          type: "number",
          span: 6,
          config: {
            edit: false
          }
        },
        {
          code: "phy4Code",
          name: "副体质4编码",
          type: "text",
          span: 6,
          config: {
            edit: false
          }
        },
        {
          code: "phy4Name",
          name: "副体质4名称",
          type: "text",
          span: 6,
          config: {
            edit: false
          }
        },
        {
          code: "phyPct4",
          name: "副体质4程度",
          type: "number",
          span: 6,
          config: {
            edit: false
          }
        },
        {
          code: "phy5Code",
          name: "副体质5编码",
          type: "text",
          span: 6,
          config: {
            edit: false
          }
        },
        {
          code: "phy5Name",
          name: "副体质5名称",
          type: "text",
          span: 6,
          config: {
            edit: false
          }
        },
        {
          code: "phyPct5",
          name: "副体质5程度",
          type: "number",
          span: 6,
          config: {
            edit: false
          }
        },
        {
          code: "phy6Code",
          name: "副体质6编码",
          type: "text",
          span: 6,
          config: {
            edit: false
          }
        },
        {
          code: "phy6Name",
          name: "副体质6名称",
          type: "text",
          span: 6,
          config: {
            edit: false
          }
        },
        {
          code: "phyPct6",
          name: "副体质6程度",
          type: "number",
          span: 6,
          config: {
            edit: false
          }
        },
        {
          code: "phy7Code",
          name: "副体质7编码",
          type: "text",
          span: 6,
          config: {
            edit: false
          }
        },
        {
          code: "phy7Name",
          name: "副体质7名称",
          type: "text",
          span: 6,
          config: {
            edit: false
          }
        },
        {
          code: "phyPct7",
          name: "副体质7程度",
          type: "number",
          span: 6,
          config: {
            edit: false
          }
        },
        {
          code: "phy8Code",
          name: "副体质8编码",
          type: "text",
          span: 6,
          config: {
            edit: false
          }
        },
        {
          code: "phy8Name",
          name: "副体质8名称",
          type: "text",
          span: 6,
          config: {
            edit: false
          }
        },
        {
          code: "phyPct8",
          name: "副体质8程度",
          type: "number",
          span: 6,
          config: {
            edit: false
          }
        },
        {
          code: "phyDiagSign",
          name: "体质诊断标注标识",
          type: "select",
          span: 6,
          config: {
            edit: false,
            keyField: "key",
            valueField: "value",
            options: [
              { key: "0", value: "未标注" },
              { key: "1", value: "已标注" }
            ]
          }
        },
        {
          code: "faceImg",
          name: "诊断健康指数",
          type: "oss",
          span: 6,
          config: {
            edit: false
          }
        },
        {
          code: "faceRecognitionSign",
          name: "面部检测结果",
          type: "select",
          span: 6,
          config: {
            edit: false,
            keyField: "key",
            valueField: "value",
            options: [
              { key: "0", value: "未测出人脸" },
              { key: "1", value: "测出人脸" }
            ]
          }
        },
        {
          code: "faceColorSign",
          name: "面部颜色结果",
          type: "select",
          span: 6,
          config: {
            edit: false,
            keyField: "key",
            valueField: "value",
            options: [
              { key: "0", value: "面白" },
              { key: "1", value: "面黑" },
              { key: "2", value: "面红" },
              { key: "3", value: "面黄" },
              { key: "4", value: "面青" },
              { key: "5", value: "正常" }
            ]
          }
        },
        {
          code: "faceLustreSign",
          name: "面部色泽结果",
          type: "select",
          span: 6,
          config: {
            edit: false,
            keyField: "key",
            valueField: "value",
            options: [
              { key: "0", value: "有光泽" },
              { key: "1", value: "少光泽" },
              { key: "2", value: "无光泽" }
            ]
          }
        },
        {
          code: "lipRecognitionSign",
          name: "嘴唇检测结果",
          type: "select",
          span: 6,
          config: {
            edit: false,
            keyField: "key",
            valueField: "value",
            options: [
              { key: "0", value: "未测出嘴唇" },
              { key: "1", value: "测出嘴唇" }
            ]
          }
        },
        {
          code: "lipColorSign",
          name: "嘴唇颜色结果",
          type: "select",
          span: 6,
          config: {
            edit: false,
            keyField: "key",
            valueField: "value",
            options: [
              { key: "0", value: "淡白" },
              { key: "1", value: "淡红" },
              { key: "2", value: "红" },
              { key: "3", value: "暗红" },
              { key: "4", value: "紫" }
            ]
          }
        },
        {
          code: "faceDiagSign",
          name: "面诊诊断标注标识",
          type: "select",
          span: 6,
          config: {
            edit: false,
            keyField: "key",
            valueField: "value",
            options: [
              { key: "0", value: "未标注" },
              { key: "1", value: "已标注" }
            ]
          }
        },
        {
          code: "diagFaceColorSign",
          name: "诊断面部颜色结果",
          type: "select",
          span: 6,
          config: {
            edit: false,
            keyField: "key",
            valueField: "value",
            options: [
              { key: "0", value: "面白" },
              { key: "1", value: "面黑" },
              { key: "2", value: "面红" },
              { key: "3", value: "面黄" },
              { key: "4", value: "面青" },
              { key: "5", value: "正常" }
            ]
          }
        },
        {
          code: "diagFaceLustreSign",
          name: "诊断面部色泽结果",
          type: "select",
          span: 6,
          config: {
            edit: false,
            keyField: "key",
            valueField: "value",
            options: [
              { key: "0", value: "有光泽" },
              { key: "1", value: "少光泽" },
              { key: "2", value: "无光泽" }
            ]
          }
        },
        {
          code: "diagLipColorSign",
          name: "诊断嘴唇颜色结果",
          type: "select",
          span: 6,
          config: {
            edit: false,
            keyField: "key",
            valueField: "value",
            options: [
              { key: "0", value: "淡白" },
              { key: "1", value: "淡红" },
              { key: "2", value: "红" },
              { key: "3", value: "暗红" },
              { key: "4", value: "紫" }
            ]
          }
        },
        {
          code: "tongueImg",
          name: "舌诊图像",
          type: "oss",
          span: 6,
          config: {
            edit: false
          }
        },
        {
          code: "tongueRecognitionSign",
          name: "舌体检测结果",
          type: "select",
          span: 6,
          config: {
            edit: false,
            keyField: "key",
            valueField: "value",
            options: [
              { key: "0", value: "未测出舌象" },
              { key: "1", value: "测出舌象" }
            ]
          }
        },
        {
          code: "tongueCrackSign",
          name: "舌裂纹检测结果",
          type: "select",
          span: 6,
          config: {
            edit: false,
            keyField: "key",
            valueField: "value",
            options: [
              { key: "0", value: "未检测到舌裂纹" },
              { key: "1", value: "检测到舌裂纹" }
            ]
          }
        },
        {
          code: "tongueFatSign",
          name: "舌胖瘦检测结果",
          type: "select",
          span: 6,
          config: {
            edit: false,
            keyField: "key",
            valueField: "value",
            options: [
              { key: "0", value: "正常" },
              { key: "1", value: "胖舌" }
            ]
          }
        },
        {
          code: "tongueCoatThickSign",
          name: "舌苔厚薄检测结果",
          type: "select",
          span: 6,
          config: {
            edit: false,
            keyField: "key",
            valueField: "value",
            options: [
              { key: "0", value: "薄" },
              { key: "1", value: "厚" }
            ]
          }
        },
        {
          code: "tongueCoatColorSign",
          name: "舌苔颜色检测结果",
          type: "select",
          span: 6,
          config: {
            edit: false,
            keyField: "key",
            valueField: "value",
            options: [
              { key: "0", value: "苔白" },
              { key: "1", value: "苔黄" }
            ]
          }
        },
        {
          code: "tongueColorSign",
          name: "舌质颜色检测结果",
          type: "select",
          span: 6,
          config: {
            edit: false,
            keyField: "key",
            valueField: "value",
            options: [
              { key: "0", value: "舌暗红" },
              { key: "1", value: "舌淡白" },
              { key: "2", value: "舌淡红" },
              { key: "3", value: "舌红" },
              { key: "4", value: "舌深红(舌紫)" }
            ]
          }
        },
        {
          code: "tongueDiagSign",
          name: "舌诊诊断标注标识",
          type: "select",
          span: 6,
          config: {
            edit: false,
            keyField: "key",
            valueField: "value",
            options: [
              { key: "0", value: "未标注" },
              { key: "1", value: "已标注" }
            ]
          }
        },
        {
          code: "diagTongueCrackSign",
          name: "诊断舌裂纹检测结果",
          type: "select",
          span: 6,
          config: {
            edit: false,
            keyField: "key",
            valueField: "value",
            options: [
              { key: "0", value: "未检测到舌裂纹" },
              { key: "1", value: "检测到舌裂纹" }
            ]
          }
        },
        {
          code: "diagTongueFatSign",
          name: "诊断舌胖瘦检测结果",
          type: "select",
          span: 6,
          config: {
            edit: false,
            keyField: "key",
            valueField: "value",
            options: [
              { key: "0", value: "正常" },
              { key: "1", value: "胖舌" }
            ]
          }
        },
        {
          code: "diagTongueCoatThickSign",
          name: "诊断舌苔厚薄检测结果",
          type: "select",
          span: 6,
          config: {
            edit: false,
            keyField: "key",
            valueField: "value",
            options: [
              { key: "0", value: "薄" },
              { key: "1", value: "厚" }
            ]
          }
        },
        {
          code: "diagTongueCoatColorSign",
          name: "诊断舌苔颜色检测结果",
          type: "select",
          span: 6,
          config: {
            edit: false,
            keyField: "key",
            valueField: "value",
            options: [
              { key: "0", value: "苔白" },
              { key: "1", value: "苔黄" }
            ]
          }
        },
        {
          code: "diagTongueColorSign",
          name: "诊断舌质颜色检测结果",
          type: "select",
          span: 6,
          config: {
            edit: false,
            keyField: "key",
            valueField: "value",
            options: [
              { key: "1", value: "舌暗红" },
              { key: "2", value: "舌淡白" },
              { key: "2", value: "舌淡红" },
              { key: "2", value: "舌红" },
              { key: "2", value: "舌深红(舌紫)" }
            ]
          }
        }
      ]
    }
  },
  computed: {
    // 计算副体质的数量
    subPhyCount() {
      let count = 0
      for (let i = 1; i <= 8; i++) {
        if (this.printData['phy' + i + 'Name']) {
          count++
        }
      }
      return count
    }
  },
  mounted() {

  },
  methods: {
    // 获取副体质列表
    getSubPhyList() {
      const list = []
      for (let i = 1; i <= 8; i++) {
        if (this.printData['phy' + i + 'Name']) {
          list.push({
            index: i,
            code: this.printData['phy' + i + 'Code'],
            name: this.printData['phy' + i + 'Name'],
            pct: this.printData['phyPct' + i]
          })
        }
      }
      return list
    },
    handleClose() {
      this.show = false
    },
    getsrc(url) {
      if (url) {
        return getSrc('', url)
      }
    },
    handleOpen() {
      this.show = true
    },
    // 获取二维码图片路径
    getQRCodeSrc() {
    // 尝试多种方式获取二维码图片
      if (this.printData.qrCodeUrl) {
        return this.getsrc(this.printData.qrCodeUrl)
      }

      // 如果打印数据中没有二维码，使用默认的二维码
      // 使用 require 确保构建时正确处理路径
      const defaultQR = require('@/assets/health/qr.jpg')

      // 如果是生产环境，可能需要完整的 URL
      if (process.env.NODE_ENV === 'production') {
      // 获取基础路径
        const baseUrl = window.location.origin
        const publicPath = process.env.VUE_APP_PUBLIC_PATH || '/'

        // 处理图片路径
        if (defaultQR && defaultQR.default) {
          return baseUrl + publicPath + defaultQR.default.replace(/^.*[\\\/]/, '')
        } else if (typeof defaultQR === 'string') {
          if (defaultQR.startsWith('http')) {
            return defaultQR
          } else {
            return baseUrl + publicPath + defaultQR.replace(/^.*[\\\/]/, '')
          }
        }
      }

      return defaultQR
    },
    async print() {
      try {
        // ========== 1. 修正A4尺寸配置（关键：用pt单位更精准，1pt=1/72英寸，A4=595pt宽×842pt高） ==========
        const A4_WIDTH_PT = 595 // A4宽度（固定）
        const A4_HEIGHT_PT = 842 // A4高度（固定）
        const PAGE_MARGIN_PT = 20 // 页面内边距（打印区域边距）
        const HEADER_HEIGHT_PT = 50 // 表头高度（含分割线）
        // 单页可容纳的内容高度（A4总高 - 上下边距×2 - 表头高度）
        const MAX_CONTENT_HEIGHT_PT = A4_HEIGHT_PT - (PAGE_MARGIN_PT * 2) - HEADER_HEIGHT_PT

        // ========== 2. 获取并克隆打印内容 ==========
        const printContent = document.getElementById('printId').cloneNode(true)

        // 处理所有图片路径
        const images = printContent.querySelectorAll('img')
        images.forEach(img => {
          // 处理二维码图片 - 使用绝对路径
          if (img.alt === '二维码') {
            // const qrSrc = this.getQRCodeSrc()
            // if (qrSrc) {
            //   img.src = qrSrc
            //   console.log('二维码路径设置为:', qrSrc)
            // }
          } else if (img.src.includes('@/assets')) {
            const imgName = img.src.split('/').pop()
            const baseUrl = window.location.origin
            const publicPath = process.env.VUE_APP_PUBLIC_PATH || '/'
            img.src = baseUrl + publicPath + 'img/' + imgName
            console.log('资源图片路径设置为:', img.src)
          }
          img.style.display = 'block'
          img.style.margin = '0 auto'

          // 添加打印样式类
          // img.classList.add('print-image')
        })

        // ========== 3. 提取页面样式 ==========
        let styles = ''
        Array.from(document.querySelectorAll('style')).forEach(styleTag => {
          styles += styleTag.innerHTML + '\n'
        })

        // ========== 4. 强化样式 - 添加打印专用样式 ==========
        const printStyles = `
      /* 表格样式 */
      .formItem {
        width: 150px;
        background: #F2F3F5 !important;
        border: 1px solid rgb(229, 230, 235) !important;
        height: 40px;
        display: flex;
        align-items: center;
        padding-left: 10px;
        -webkit-print-color-adjust: exact !important;
        print-color-adjust: exact !important;
        box-sizing: border-box;
      }

      .formItemwhite {
        width: 150px;
        border: 1px solid #E5E6EB !important;
        height: 40px;
        display: flex;
        align-items: center;
        padding-left: 10px;
        background: #FFFFFF !important;
        -webkit-print-color-adjust: exact !important;
        print-color-adjust: exact !important;
        box-sizing: border-box;
      }

      /* 二维码样式 */
      .print-image {
        max-width: 100% !important;
        height: auto !important;
        display: block !important;
      }

      img[alt="二维码"],
      img[src*="qr"] {
        width: 120px !important;
        height: 120px !important;
        object-fit: contain !important;
        margin: 0 auto !important;
      }

      /* 打印优化 */
      @media print {
        * {
          -webkit-print-color-adjust: exact !important;
          print-color-adjust: exact !important;
        }

        body {
          margin: 0 !important;
          padding: 0 !important;
          background: white !important;
        }

        .print-page {
          break-inside: avoid;
          background: white !important;
        }

        /* 确保所有元素在打印时可见 */
        #printId * {
          visibility: visible !important;
        }

        /* 隐藏不需要打印的元素 */
        .el-dialog__header,
        .el-dialog__footer,
        .dialog-footer {
          display: none !important;
        }
      }

      /* 体质模块样式 */
      .main-phy-large {
        box-shadow: 0 4px 12px rgba(22, 93, 255, 0.1) !important;
        position: relative;
        overflow: hidden;
      }

      .main-phy-large::before {
        content: '';
        position: absolute;
        top: 0;
        left: 0;
        width: 5px;
        height: 100%;
        background: linear-gradient(to bottom, #165dff, #8bb5ff);
      }

      .sub-phy-item {
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05) !important;
      }
    `

        // ========== 5. 强化内容分片逻辑（支持单个长元素拆分） ==========
        const pageFragments = []
        let currentFragment = document.createElement('div')
        currentFragment.style.width = `${A4_WIDTH_PT}pt` // 强制和A4同宽，确保测量准确

        // 测量元素在A4宽度下的高度（单位：pt）
        const measureElementHeightPt = (el) => {
          const temp = document.createElement('div')
          temp.style.visibility = 'hidden'
          temp.style.position = 'absolute'
          temp.style.width = `${A4_WIDTH_PT}pt` // 强制A4宽度
          temp.style.fontSize = '12pt' // 统一字体大小（避免样式差异）
          temp.appendChild(el.cloneNode(true))
          document.body.appendChild(temp)
          const heightPx = temp.offsetHeight
          document.body.removeChild(temp)
          // px转pt（1pt=1.333px）
          return heightPx / 1.333
        }

        // 递归拆分元素（处理单个长元素）
        const splitElementIntoFragments = (el) => {
          const elHeight = measureElementHeightPt(el)
          // 如果元素本身小于单页高度，直接加入当前片段
          if (elHeight <= MAX_CONTENT_HEIGHT_PT) {
            const currentFragmentHeight = measureElementHeightPt(currentFragment)
            if (currentFragmentHeight + elHeight > MAX_CONTENT_HEIGHT_PT) {
              // 当前片段放不下，先存起来
              pageFragments.push(currentFragment)
              currentFragment = document.createElement('div')
              currentFragment.style.width = `${A4_WIDTH_PT}pt`
            }
            currentFragment.appendChild(el.cloneNode(true))
            return
          }

          // 单个元素超长，拆分其内容（按文本节点拆分）
          const children = Array.from(el.childNodes)
          const tempEl = document.createElement(el.tagName)
          tempEl.style.width = `${A4_WIDTH_PT}pt`
          tempEl.style.fontSize = '12pt'

          for (const child of children) {
            const childClone = child.cloneNode(true)
            tempEl.appendChild(childClone)
            const tempHeight = measureElementHeightPt(tempEl)
            if (tempHeight > MAX_CONTENT_HEIGHT_PT) {
              // 超出了，把当前tempEl的内容加入片段，重置tempEl
              tempEl.removeChild(childClone)
              splitElementIntoFragments(tempEl)
              tempEl.innerHTML = ''
              tempEl.appendChild(childClone)
            }
          }
          // 剩余内容加入片段
          if (tempEl.childNodes.length > 0) {
            splitElementIntoFragments(tempEl)
          }
        }

        // 遍历所有内容元素，执行拆分
        Array.from(printContent.children).forEach(child => {
          splitElementIntoFragments(child)
        })

        // 加入最后一个片段
        if (currentFragment.childNodes.length > 0) {
          pageFragments.push(currentFragment)
        }

        console.log(`生成了 ${pageFragments.length} 个打印片段`)

        // ========== 6. 渲染多页内容 ==========
        const printWindow = window.open('', '_blank')

        // 构建完整的打印HTML
        const printHtml = `
      <!DOCTYPE html>
      <html>
        <head>
          <title>体质检测报告 - ${this.printData.userName || '未命名用户'}</title>
          <meta charset="UTF-8">
          <style>
            ${styles}
            ${printStyles}

            /* 打印核心样式 */
            @page {
              size: A4;
              margin: ${PAGE_MARGIN_PT}pt;
            }

            body {
              margin: 0;
              padding: 0;
              font-family: "Microsoft YaHei", Arial, sans-serif;
              font-size: 12pt;
              -webkit-print-color-adjust: exact;
              print-color-adjust: exact;
              background: white;
            }

            /* 每页容器 */
            .print-page {
              width: ${A4_WIDTH_PT - (PAGE_MARGIN_PT * 2) + 65}pt;
              min-height: ${A4_HEIGHT_PT - (PAGE_MARGIN_PT * 2)}pt;
              padding: 10px 20px;
              box-sizing: border-box;
              page-break-after: always;
              position: relative;
              background: white;
              border: 1px solid #666;
            }

            .print-page:last-child {
              page-break-after: auto;
            }

            /* 表头样式 */
            .print-header {
              width: 100%;
              height: ${HEADER_HEIGHT_PT}pt;
              margin-bottom: 10pt;

              padding-bottom: 10pt;
            }

            .print-header-content {
              display: flex;
              justify-content: space-between;
              align-items: flex-start;
              border-bottom: 1px solid #666;
            }

            .user-name {
              font-size: 18pt;
              font-weight: bold;
            }

            .header-right {
              text-align: right;
            }

            .entry-time {
              font-size: 12pt;
              color: #666;
            }

            .code-info {
              text-align: right;
              font-size: 12pt;
              padding-bottom: 5pt;
            }

            .disclaimer {
              text-align: right;
              color: #666;
              font-size: 10pt;
            }

            /* 内容区域 */
            .print-content {
              width: 100%;
              padding-top: 10pt;
            }

            /* 屏幕预览样式 */
            @media screen {
              body {
                background: #f0f2f5;
                padding: 20px;
              }
              .print-preview {
                max-width: 800px;
                margin: 0 auto;
              }
              .print-page {
                margin-bottom: 20px;
                background: white;
                box-shadow: 0 2px 8px rgba(0,0,0,0.1);
                padding: 20px;
              }
            }
          </style>
        </head>
        <body>
          <div class="print-preview">
            ${pageFragments.map((fragment, index) => `
              <div class="print-page">
                <div class="print-header">
                  <div class="print-header-content">
                    <div class="user-name">${this.printData.userName || ''}</div>
                    <div class="header-right">
                      <div class="entry-time">${this.printData.entryTime || this.printData.diagTime || ''}</div>
                    </div>
                  </div>
                  <div class="code-info">编号: ${this.printData.code || ''}</div>
                  <div class="disclaimer">检测结果仅供参考，不作为医疗诊断依据</div>
                </div>
                <div class="print-content">
                  ${fragment.innerHTML}
                </div>
              </div>
            `).join('')}
          </div>
        </body>
      </html>
    `

        printWindow.document.write(printHtml)
        printWindow.document.close()

        // ========== 7. 图片加载完成后触发打印 ==========
        printWindow.onload = () => {
          // 确保所有图片加载完成
          const printImages = printWindow.document.querySelectorAll('img')
          let loadedImages = 0
          const totalImages = printImages.length

          console.log(`等待 ${totalImages} 张图片加载完成...`)

          if (totalImages === 0) {
            // 没有图片，直接打印
            this.triggerPrint(printWindow)
          } else {
            // 监听每张图片的加载
            printImages.forEach(img => {
              if (img.complete) {
                loadedImages++
                console.log(`图片已加载: ${img.src}`)
                if (loadedImages === totalImages) {
                  this.triggerPrint(printWindow)
                }
              } else {
                img.onload = () => {
                  loadedImages++
                  console.log(`图片加载成功: ${img.src}`)
                  if (loadedImages === totalImages) {
                    this.triggerPrint(printWindow)
                  }
                }
                img.onerror = () => {
                  loadedImages++
                  console.error(`图片加载失败: ${img.src}`)
                  if (loadedImages === totalImages) {
                    this.triggerPrint(printWindow)
                  }
                }
              }
            })
          }
        }
      } catch (error) {
        console.error('打印失败:', error)
        this.$message.error('打印失败，请重试')
      }
    },

    // 添加辅助方法到methods中
    triggerPrint(printWindow) {
      setTimeout(() => {
        printWindow.focus()
        printWindow.print()
        setTimeout(() => {
          printWindow.close()
        }, 500)
      }, 1000)
    },
    getOptions(code, key) {
      let text = ''
      this.columns.forEach(element => {
        if (element.code === code) {
          element.config.options.map(item => {
            if (key === item.key) {
              text = item.value
            }
          })
        }
      })
      return text
    }
  }
}
</script>
<style lang="scss" scoped>
/* 屏幕预览样式 */
#printId {
  background: white;
  padding: 20px;
}

/* 打印样式 */
@media print {
@page {
  margin: 15mm;
  @top-right {
    content: "第" counter(page) "页";
    font-size: 12px;
    color: #999;
  }
}

body {
  counter-reset: page;
}

.print-page {
  counter-increment: page;
}

/* 隐藏页面上的页码显示，使用@top-right的页码 */
.page-number {
  display: none;
}
  .print-header {
    position: fixed !important;
    top: 0 !important;
    left: 0 !important;
    right: 0 !important;
    background: white !important;
    z-index: 1000 !important;
  }

  #printId {
    margin-top: 100px !important;
  }
}

/* 表单样式保持不变 */
.formItem {
  width: 150px;
  background: #F2F3F5;
  border: 1px solid rgb(229, 230, 235);
  height: 40px;
  display: flex;
  align-items: center;
  padding-left: 10px;
}

.formItemwhite {
  width: 150px;
  border: 1px solid #E5E6EB;
  height: 40px;
  display: flex;
  align-items: center;
  padding-left: 10px;
  background: #FFFFFF;
}

/* 体质模块样式 */
.main-phy-large {
  box-shadow: 0 4px 12px rgba(22, 93, 255, 0.1);
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}

.main-phy-large::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 5px;
  height: 100%;
  background: linear-gradient(to bottom, #165dff, #8bb5ff);
}

.sub-phy-item {
  transition: all 0.3s ease;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.sub-phy-item:hover {
  transform: translateY(-3px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}
/* 增强打印样式 */
@media print {
  /* 确保表格边框在打印时可见 */
  .formItem, .formItemwhite {
    -webkit-print-color-adjust: exact;
    print-color-adjust: exact;
    background-color: #F2F3F5 !important;
    border: 1px solid #E5E6EB !important;
  }

  .formItemwhite {
    background-color: #FFFFFF !important;
  }

  /* 确保所有打印内容可见 */
  #printId * {
    visibility: visible !important;
  }

  /* 隐藏不需要打印的元素 */
  .el-dialog__header,
  .el-dialog__footer,
  .dialog-footer {
    display: none !important;
  }

  /* 确保打印区域完整显示 */
  #printId {
    margin: 0 !important;
    padding: 0 !important;
    width: 100% !important;
    max-width: none !important;
    min-height: 100vh !important;
  }

  /* 确保页面边距合理 */
  @page {
    margin: 15mm !important;
  }
}
</style>
